import Dashboard from "components/dashboard/Dashboard";
import UserGUI from "./components/UserGUI";
import usePageTitle from "config/useTitle";
import styles from "./DashboardPage.module.css";

const DashboardPage = () => {
  usePageTitle("Dashboard");

  return (
    <div className={`container ${styles.dashboardPage}`}>
      <Dashboard />
      <UserGUI />
    </div>
  );
};

export default DashboardPage;
